import Vue from 'vue';
import { DateTime } from 'luxon';

Vue.filter('formatDate', value => {
  if (!value) {
    return '';
  }

  const format = {
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
    hour: '2-digit',
    minute: '2-digit',
    second: '2-digit',
  }
  // return moment(String(value)).format('MM/DD/YYYY hh:mm');
  return DateTime.fromISO(value).setLocale('it').toLocaleString(format);
});

Vue.filter('formatTime', value => {
  if (!value) {
    return '';
  }
  
  const format = {
    hour: '2-digit',
    minute: '2-digit',
    second: '2-digit',
  }
  return DateTime.fromISO(value).setLocale('it').toLocaleString(format);
});
